import React from 'react';
import PropTypes from 'prop-types';

import {
    Icon as StyledIcon,
    Link as StyledLink,
    Nav as StyledNav,
    Text as StyledText,
} from './styles';

export const Nav = ({ children, ...others }) => (
    <StyledNav {...others}>{children}</StyledNav>
);

Nav.propTypes = { children: PropTypes.any.isRequired };

export const Link = ({ children, ...others }) => (
    <StyledLink {...others}>{children}</StyledLink>
);

Link.propTypes = {
    children: PropTypes.any.isRequired,
};

Link.Icon = ({ name, className, ...otherProps}) => {
    const classes = ['ico-product', className, name].join(' ');
    return <StyledIcon className={classes} {...otherProps} />;
};
Link.Icon.displayName = 'Link.Icon';

Link.Icon.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
};

Link.Text = ({ children, ...others}) => (
    <StyledText {...others}>{children}</StyledText>
);
Link.Text.displayName = 'Link.Text';

Link.Text.propTypes = { children: PropTypes.any };
